import { useMediaQuery } from "@mantine/hooks";

export const useIsMobile = (requestHeaders?: {
  [key: string]: string;
}): boolean => {
  // Check user-agent for SSR initial value to prevent layout flash
  // Header key might be "user-agent" or "User-Agent" depending on environment
  const userAgent =
    requestHeaders?.["user-agent"] ||
    requestHeaders?.["User-Agent"] ||
    "";
  const userAgentLooksMobile =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent,
    );

  // Pass user-agent detection as initial value to prevent flash during hydration
  const isMobile = useMediaQuery("(max-width: 1024px)", userAgentLooksMobile, {
    getInitialValueInEffect: false,
  });

  return isMobile ?? userAgentLooksMobile;
};
